import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=534f9250&scoped=true&"
import script from "./ring.vue?vue&type=script&lang=js&"
export * from "./ring.vue?vue&type=script&lang=js&"
import style0 from "./ring.vue?vue&type=style&index=0&id=534f9250&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f9250",
  null
  
)

export default component.exports